import { Typography } from "@mui/material";

import Svg, { SvgEnum } from "../../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../../ui library/HNSColors";
import { STRINGS } from "../utils/strings";

export default function CaseHealthListItem({ issue }) {
  const {
    flagDescription = "",
    flagName = "",
    errorMessage = "",
    flagState: rawFlagState = 0,
  } = issue;
  const flagState = Number.isNaN(Number(rawFlagState)) ? null : Number(rawFlagState);
  return (
    <div
      className="justiy-start flex w-full flex-col gap-[18px] rounded-[14px] border px-[22px] py-[32px]"
      style={{
        borderColor: HNSColors.primary[900],
      }}
    >
      <div className="flex flex-row items-center justify-between">
        <Typography className="text-xl font-semibold">{flagName}</Typography>
        <Svg
          name={STRINGS.flagState[flagState].iconName}
          color={STRINGS.flagState[flagState]?.color}
          sx={{
            height: "35px",
            width: "35px",
          }}
        />
      </div>
      <div className="flex flex-row gap-[18px]">
        <Svg
          name={SvgEnum.HisClock}
          color={HNSColors.primary[500]}
          sx={{
            height: "24px",
            width: "24px",
          }}
        />
        <Typography className="text-base font-normal">{flagDescription}</Typography>
      </div>
      {errorMessage && (
        <div
          className="items-center-safe flex w-fit gap-[8px] rounded-[12px] border-[1px] px-[22px] py-[12px]"
          style={{
            borderColor: STRINGS.flagState[flagState]?.borderColor,
            backgroundColor: STRINGS.flagState[flagState]?.bgColor,
          }}
        >
          <Svg
            name={SvgEnum.HisAlertCircle}
            color={STRINGS.flagState[flagState]?.color}
            sx={{
              height: "20px",
              width: "20px",
            }}
          />
          <Typography className="text-base font-normal">{errorMessage}</Typography>
        </div>
      )}
    </div>
  );
}
